module.exports = __webpack_public_path__ + "img/protester6.223c42a0.jpg";